import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2)
  },
  postalDisplay: {
    [theme.breakpoints.up("md")]: {
      width: "25vw"
    },
    [theme.breakpoints.down("md")]: {
      width: "80vw"
    },
    "@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 1)": {
      marginTop: theme.spacing(5)
    },
  },
  postalConfirm: {
    padding: "1em 2em",
    [theme.breakpoints.up("md")]: {
      width: "25vw"
    },
    [theme.breakpoints.down("md")]: {
      width: "80vw",
      fontWeight: 600
    },
    color: "#fff",
    backgroundColor: "#FB7906",
    '&:hover': {
      backgroundColor: '#e46b00',
      boxShadow:"0px 0px 5px #e46b00"
    },
    borderRadius:"0px 8px"
  },
}));
